import { sessionApi } from './session.api';

export const createSession = () => () =>
  sessionApi.createSession().then((response) => {
    if (response.status === 201) {
      window.location.reload();
    }
  });

export const sessionActions = {
  createSession,
};
